import { render, staticRenderFns } from "./project-select.vue?vue&type=template&id=06656619"
import script from "./project-select.vue?vue&type=script&lang=js"
export * from "./project-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports